import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { InfoModal } from "../index";


const info = {
  "Projected Return Rate": {
    title: "Projected Return Rate",
    message:
      "Projected gross return (excludes management and Trustee fees) by Principal Malaysia for the next 12 months. It may vary depending on market performance.",
  },
  "Total Return": {
    title: "Total Return",
    message:
      "Total Return is the sum of your daily return accumulated from the day of your initial Cash In.",
  },
  "Investment Cost": {
    title: "Investment Cost",
    message:
      "Investment Cost is the Total cost of your units accumulated from your Cash In. It is the average cost of a unit multiplied with your total units held",
  },
};

const detailCss = {
  fontWeight: "900",
  fontSize: "16px",
  lineHeight: 1.31,
  color: "#fff"
};

const SavingDetailCard = ({
  label,
  detail,
  icon,
  isMoney,
  needNumberFormat,
  decimalSet,
  planAlias,
  labelStyle,
}) => {
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        borderRadius: "4px",
        border: "solid 1px rgba(255, 255, 255, 0.05)",
        backgroundColor: "rgba(255, 255, 255, 0.08)",
        width: "100%"
      }}
    >
      <InfoModal
        open={isInfoOpen}
        handleClose={() => setIsInfoOpen(false)}
        title={typeof info[label] === "object" && info[label].title}
        message={typeof info[label] === "object" && info[label].message}
      />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {icon && <img src={icon} alt="saving-detail" />}
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: 1.5,
            color: "#fff",
            marginLeft: icon ? "8px" : 0,
            ...(labelStyle || {}),
          }}
        >
          {label}
        </Typography>
      </Box>
      {label === "Projected Return Rate" ||
      label === "Total Return" ||
      label === "Investment Cost" ? (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {!isMoney ? (
            <Typography
              sx={detailCss}
            >
              {detail}
            </Typography>
          ) : (
            <Typography
              sx={detailCss}
            >
              {detail < 0 && "-"}RM{" "}
              <NumberFormat
                value={detail > 0 ? detail : detail * -1}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </Typography>
          )}
          <InfoOutlinedIcon
            fontSize="small"
            sx={{ cursor: "pointer", color: "#fff" }}
            onClick={() => setIsInfoOpen(true)}
          />
        </div>
      ) : (
        <>
          {!isMoney ? (
            needNumberFormat ? (
              <Typography
                sx={detailCss}
              >
                <NumberFormat
                  value={detail}
                  thousandSeparator
                  displayType="text"
                  decimalScale={decimalSet ? decimalSet : 2}
                  fixedDecimalScale={true}
                />
              </Typography>
            ) : (
              <Typography
                sx={detailCss}
              >
                {detail}
              </Typography>
            )
          ) : (
            <Typography
              sx={detailCss}
            >
              RM{" "}
              <NumberFormat
                value={detail}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale={true}
              />
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default SavingDetailCard;
